import React from "react";
import { Info, TriangleAlert, Siren, OctagonAlert, CheckCircle2, CircleDot } from "lucide-react";

const SEVERITY_MAP = {
  info: { className: "tt-sev-info", icon: Info, label: "Info" },
  warning: { className: "tt-sev-warning", icon: TriangleAlert, label: "Uwaga" },
  urgent: { className: "tt-sev-urgent", icon: Siren, label: "Pilne" },
  critical: { className: "tt-sev-critical", icon: OctagonAlert, label: "Krytyczne" },
};

const STATUS_MAP = {
  draft: { className: "tt-sev-neutral", icon: CircleDot, label: "Robocze" },
  submitted: { className: "tt-sev-info", icon: Info, label: "Wysłane" },
  approved: { className: "tt-sev-success", icon: CheckCircle2, label: "Zatwierdzone" },
  rejected: { className: "tt-sev-critical", icon: OctagonAlert, label: "Odrzucone" },
  corrected: { className: "tt-sev-warning", icon: TriangleAlert, label: "Korekta" },
  active: { className: "tt-sev-success", icon: CheckCircle2, label: "Aktywny" },
  sold: { className: "tt-sev-info", icon: Info, label: "Sprzedany" },
  partially_used: { className: "tt-sev-warning", icon: TriangleAlert, label: "Częściowo użyty" },
  used: { className: "tt-sev-neutral", icon: CheckCircle2, label: "Wykorzystany" },
  cancelled: { className: "tt-sev-critical", icon: OctagonAlert, label: "Anulowany" },
  expired: { className: "tt-sev-neutral", icon: TriangleAlert, label: "Przeterminowany" },
  open: { className: "tt-sev-urgent", icon: Siren, label: "Otwarty" },
  acknowledged: { className: "tt-sev-info", icon: Info, label: "Potwierdzony" },
  closed: { className: "tt-sev-success", icon: CheckCircle2, label: "Zamknięty" },
};

export function StatusBadge({ value, kind = "workflow", className = "" }) {
  const map = kind === "severity" ? SEVERITY_MAP : STATUS_MAP;
  const conf = map[value] || { className: "tt-sev-neutral", icon: Info, label: value || "?" };
  const Icon = conf.icon;
  return (
    <span className={`tt-badge ${conf.className} ${className}`} data-testid={`status-badge-${value}`}>
      <Icon className="h-3.5 w-3.5" />
      {conf.label}
    </span>
  );
}

export function SeverityBadge({ level, className = "" }) {
  return <StatusBadge value={level} kind="severity" className={className} />;
}
